import { useEffect } from 'react';
import toast, { useToasterStore } from 'react-hot-toast';

// One toast on screen at a time: a new toast replaces the one showing
// (react-hot-toast stacks them, and an old "Conversation created" sat under the
// next message for its full duration; staging UI run 2026-10-13). Rendered
// next to each <Toaster />.
export const MAX_VISIBLE_TOASTS = 1;

export default function ToastLimit({ max = MAX_VISIBLE_TOASTS }) {
  const { toasts } = useToasterStore();
  useEffect(() => {
    toasts
      .filter((t) => t.visible)
      .slice(max) // the store lists the newest first
      .forEach((t) => toast.dismiss(t.id));
  }, [toasts, max]);
  return null;
}
